import React from "react";
import appRoutes from "../../../routes/app.routes";
import { CANDIDATE_CHIPS, EMPLOYER_TAGS } from "../homeV2.constants";
import HvButton from "./HvButton";
import Reveal from "./Reveal";

const EmployerSection = () => {
  return (
    <section className="hv2-employer" id="employer-section">
      <div className="home-v2__container hv2-employer__grid">
        <Reveal>
          <span className="home-v2__label hv2-employer__label">For Employers</span>
          <h2 className="home-v2__h2 hv2-employer__title">
            Great teams start with people you might <span className="home-v2__highlight">otherwise miss</span>
          </h2>
          <p className="hv2-employer__sub">
            Candidate cards animate into a shortlist. Discover talent beyond keywords.
          </p>
          <div className="hv2-employer__btn-group">
            <HvButton variant="primary" to={appRoutes.salesInquiry.generatePath()}>
              Discover Talent →
            </HvButton>
            <HvButton variant="outline-on-dark" to={appRoutes.salesInquiry.generatePath()}>
              Post jobs for free
            </HvButton>
            <HvButton variant="outline-on-dark" to={appRoutes.contactUs.path}>
              Talk to employHER
            </HvButton>
          </div>
          <div className="hv2-employer__tags">
            {EMPLOYER_TAGS.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.08} className="hv2-employer__visual">
          {CANDIDATE_CHIPS.map((chip) => (
            <div className="hv2-candidate-chip" key={chip.name}>
              <img src={chip.avatarUrl} alt={chip.name} className="hv2-candidate-chip__avatar" />
              <div>
                <div className="hv2-candidate-chip__name">{chip.name}</div>
                <div className="hv2-candidate-chip__role">{chip.role}</div>
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default EmployerSection;
